import { HtmlHTMLAttributes } from 'react';
import DOMPurify from 'dompurify';

type TagProps = 'div' | 'span' | 'p';

type RenderHtmlProps = {
    html: string;
    className?: string;
    tag?: string;
} & HtmlHTMLAttributes<HTMLDivElement>;

const RenderHtml = ({ html, className, tag = 'div', ...rest }: RenderHtmlProps): JSX.Element => {
    const Tag = tag as TagProps;
    return <Tag dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} {...rest} className={className} />;
};

export { RenderHtml };
export type { RenderHtmlProps };
